import Slider from '../../../framework/slider';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';

interface Option {
    image: string;
    title: string;
    label: string;
}
type initializeLoryType = () => void;
type addEventListenersType = () => void;


export default class CardCollectionPopup extends Slider {
    
	constructor(element:HTMLElement) {
		super({
			element,
			dotContainer: '.v2-slider__dots',
			slideContainer: '.v2-slider',
			createBullets: true,
			sliderOpts: {
				infinite: false
			}
		});
		// Initialise Lory Slider
		this.initializeLory();
		this.addEventListeners();
	}

	initializeLory:initializeLoryType = ():void => {
		if (!this.slider && this.dotCount > 1 && screenSmallerThan('sm')) {
			this.initLory(this.slideContainer);
		}
	}

	addEventListeners:addEventListenersType = ():void => {
		this.addEventListener(this.element, 'click', (e:Event) => {
			e.preventDefault();
			const section = (e.target as (HTMLElement))?.closest('.v2-card');           
			const labelLink:string =
				section?.querySelector('.v2-card__text-content .collection-popup-title a')?.outerHTML ?? '';
			const labelDesc:string =
				(section?.querySelector('.v2-card__text-content .collection-popup-desc') as HTMLElement)?.innerText ?? '';
			const picture:string = (section?.querySelector('.v2-card__hero picture img') as HTMLImageElement)?.currentSrc ?? '';

			const option: Option = {
				image: picture || '',
				title: labelDesc,
				label: labelLink
			};
			this.publish('/lightbox/open', {
				cssClass: this.element.getAttribute('data-css-class') || '',
				target: this.element.getAttribute('data-target'),
				title: this.element.getAttribute('data-title') || '',
				type: this.element.getAttribute('data-type') || 'id',
				rte: this.element.getAttribute('data-rte') || '',
				option
			});
		});
	}
}
